import { combineReducers } from 'redux';
import ResponsesReducer from './ResponsesReducer' 
import CarrerasReducer from './CarrerasReducer';
import FormDataReducer from './FormDataReducer';
import PaymentReducer from './PaymentReducer';
import { WorldPayReducer } from './WorldPayReducer';


export default combineReducers({
    carreras: CarrerasReducer,
    respuestas: ResponsesReducer,
    datosFormulario: FormDataReducer,
    payment: PaymentReducer,
    worldpay: WorldPayReducer,
});